import { GetServerSideProps } from 'next';
import Router from 'next/router';
import { parseCookies } from 'nookies';
import { useState } from 'react';
import styled from 'styled-components';
import { ModalInformation } from 'components/ModalInformation';
import Page from 'components/Page';
import { api } from 'services/apiClient';

const ResetPassword = () => {
  const [userEmail, setUserEmail] = useState<string>('');
  const [showModalInformation, setShowModalInformation] = useState<boolean>(false);
  const [messageInformation, setMessageInformation] = useState<string>('');
  const [typeMessage, setTypeMessage] = useState<'error' | 'sucess'>('sucess');

  const resetPassword = async () => {
    try {
      await api.post('/users/password', {
        email: userEmail,
      });
      setMessageInformation('Sucesso! As informações para recuperar sua senha foram enviadas para o seu e-mail.');
      setTypeMessage('sucess');
      setShowModalInformation(true);
      setTimeout(() => {
        setShowModalInformation(false);
        Router.push('/login');
      }, 4000);
    } catch (error: any) {
      setMessageInformation('Ocorreu um erro ao tentar recuperar a senha!');
      setTypeMessage('error');
      setShowModalInformation(true);
      setTimeout(() => {
        setShowModalInformation(false);
      }, 5000);
      console.log(error);
    }
  };

  return (
    <Page
      navbar
      title="Resetar senha"
      margin={false}
      description="Minim sint aliquip nostrud excepteur cupidatat amet do laborum exercitation cupidatat ea proident."
    >
      <ModalInformation
        modalIsOpen={showModalInformation}
        closeModal={setShowModalInformation}
        message={messageInformation}
        typeMessage={typeMessage}
      />
      <Container>
        <h1>Coloque seu e-mail para recuperar sua senha!</h1>
        <Group>
          <input type="email" placeholder="E-mail" onChange={(e: any) => setUserEmail(e.target.value)} />
        </Group>

        <Button onClick={resetPassword}>Recuperar a senha</Button>
      </Container>
    </Page>
  );
};

export default ResetPassword;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const cookies = parseCookies(ctx);

  if (cookies['meunascimento.token']) {
    return {
      redirect: {
        destination: '/profile/user',
        permanent: false,
      },
    };
  }

  return {
    props: {},
  };
};

const Container = styled.div`
  display: flex;
  width: 100%;
  min-height: calc(100vh - (490px + 10px));
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;

  h1 {
    color: #4397c3;
  }

`;

const Group = styled.div`
  input {
    margin-top: 2rem;
    width: 100%;
    font-size: 1.5rem;
    padding: 1rem 2rem;
    border: solid 2px #4397c3;
    border-radius: 10px;
  }

  input::placeholder {
    font-size: 15px;
    color: #174F68;
    font-weight: 500;
  }

  input:hover {
    border: solid 2px #4397c3;
    color: #174F68;
  }

  input:focus,
  select:focus {
    box-shadow: 0.3px 0.3px 0.3px;
    outline: 0;
  }
`;

const Button = styled.div`
  border-radius: 10px;
  text-align: center;
  border: none;
  font-weight: 700;
  margin-top: 2.5rem;
  padding: 1.2rem 1.2rem;
  background: #4397c3;
  font-size: 10px;
  color: #fff;
  cursor: pointer;
  text-transform: uppercase;
  transition: all 0.5s;

  :hover {
    opacity: 0.7;
  }

`;
